<template>
    <div class="new-download-container" :class="{ 'bg-gradient-lines': activeIndex === 0 }">
        <div class="content-section">
            <div class="content-inner">
                <div class="content-left">
                    <h1 class="title font-bold" :class="{ 'title-en': $i18n.locale === 'en' }">{{ activeItem.title }}</h1>
                    <p class="desc">{{ activeItem.desc }}</p>
                    <el-button
                        class="experience-btn"
                        color="#386AEA"
                        @click="handleExperience"
                    >
                        <span class="btn-text">{{ $t('newDownload.btnText') }}</span>
                    </el-button>
                </div>
            </div>
        </div>
        <!-- 图片 -->
            <div v-if="activeIndex === 0" class="content-right" :class="`img-width-studio`">
                <img :src="studioImg"/>
            </div>
            <div v-if="activeIndex === 1" class="content-right" :class="`img-width-system`">
                <img :src="imgYaocao"/>
            </div>
            <div v-if="activeIndex === 2" class="content-right" :class="`img-width-app`">
                <img :src="imgApp"/>
            </div>
            <div v-if="activeIndex === 3" class="content-right" :class="`img-width-simulation`">
                <img :src="imgFangzhen"/>
        </div>

        <div class="tab-section">
            <div class="tab-inner">
                <div class="software-label">{{ $t('newDownload.softwareLabel') }}</div>
                <div class="tab-list">
                    <div
                        v-for="(item, index) in tabList"
                        :key="item.key"
                        class="tab-item"
                        :class="{ active: activeIndex === index }"
                        @click="switchTab(index)"
                    >
                        <img
                            v-show="activeIndex === index"
                            class="tab-indicator"
                            src="@/assets/image/newDownload/download_select.png"
                            alt=""
                        />
                            <div class="tab-title font-bold">{{ item.title }}</div>
                            <div class="tab-desc">{{ item.desc }}</div>
                    </div>
                </div>
            </div>
        </div>
        <kpl-dialog
            v-model="dialogVisible"
            :title="t('newDownload.dialogTitle')"
            :content="t('newDownload.dialogContent')"
            :confirm-text="t('newDownload.dialogConfirmText')"
            @confirm="handleConfirm"
        />
    </div>
</template>

<script setup>
import { ref, computed } from 'vue'
// import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
// import { downloadFile } from '@/utils/downloadFile'
import KplDialog from '@/components/kplDialog/index.vue'
import imgYaocao from '@/assets/image/newDownload/download_yaocao.png'
import imgApp from '@/assets/image/newDownload/download_app.png'
import imgFangzhen from '@/assets/image/newDownload/download_fangzhen.png'
// import studioBg from '@/assets/image/newDownload/studio_bg.png'
import studioImg from '@/assets/image/newDownload/download_studio.png'

const { t } = useI18n()
// const router = useRouter()
const activeIndex = ref(0)
const dialogVisible = ref(false)

const tabList = computed(() => [
    {
        key: 'studio',
        title: t('newDownload.studioTitle'),
        desc: t('newDownload.studioDesc'),
        previewImg: studioImg,
        link: '/downloads',
        linkType: 'route',
    },
    {
        key: 'system',
        title: t('newDownload.systemTitle'),
        desc: t('newDownload.systemDesc'),
        previewImg: imgYaocao,
        link: '',
        linkType: 'route',
    },
    {
        key: 'app',
        title: t('newDownload.viewAppTitle'),
        desc: t('newDownload.viewAppDesc'),
        previewImg: imgApp,
        link: '/downloadApp',
        linkType: 'route',
    },
    {
        key: 'simulation',
        title: t('newDownload.simulationTitle'),
        desc: t('newDownload.simulationDesc'),
        previewImg: imgFangzhen,
        link: '',
        linkType: 'download',
    },
])

const activeItem = computed(() => tabList.value[activeIndex.value] || tabList.value[0])
// const pageStyle = computed(() => {
//     if (activeIndex.value === 0) {
//         return {
//             backgroundImage: `url(${studioBg})`,
//             backgroundSize: '100% 100%',
//             backgroundRepeat: 'no-repeat',
//             backgroundPosition: 'center center',
//         }
//     }
//     return { backgroundImage: 'none' }
// })

const switchTab = (index) => {
    activeIndex.value = index
}

const handleExperience = () => {
    const item = activeItem.value
    console.log(item)
    dialogVisible.value = true
}

const handleConfirm = () => {
    dialogVisible.value = false
}

</script>

<style lang="scss" scoped>
@use '../../style/utils.scss' as *;

.new-download-container {
    position: relative;
    min-height: calc(100vh - 56px);
    background: #1E2024;
    padding: 16vh 0 14vh;
    box-sizing: border-box;
}
.bg-gradient-lines {
    background-image: linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
    background-size: 26px 26px;
}

.content-section {
    width: 100%;
}

.content-inner {
    width: vw(1318);
    max-width: calc(100% - 80px);
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // gap: 48px;
}

.content-left {
    flex: 0 0 vw(545);
    max-width: vw(545);
    z-index: 99;

    .title {
        font-weight: 600;
        font-size: vw(32);
        color: #FFFFFF;
        line-height: vh(45);
        text-align: left;
    }
    .title-en {
        font-size: vw(30);
    }

    .desc {
        margin: vh(18) 0 0;
        font-weight: 500;
        font-size: vw(18);
        color: rgba(255,255,255,0.6);
        line-height: vh(25);
        text-align: left;
    }

    .experience-btn {
        margin-top: vw(54);
        min-width: vw(260);
        height: vw(60);
        border-radius: vw(100);
        border: none;
        background: #1454F4;

        .btn-text {
            font-weight: 700;
            font-size: vw(18);
            color: #FFFFFF;
            line-height: 25px;
            text-align: center;
        }
    }
}

.content-right {
    position: absolute;
    img {
        display: block;
        width: 100%;
        height: auto;
        object-fit: contain;
    }
}


.img-width-system {
    width: vw(900);
    top: vh(60);
    right: vw(54);
}
.img-width-app {
    width: vw(660);
    top: vh(50);
    right: vw(259);
}
.img-width-simulation {
    width: vw(750);
    top: vh(80);
    right: vw(166);
}
.img-width-studio {
    width: vw(380);
    top: vh(100);
    right: vw(550);
}

.tab-section {
    margin-top: vh(95);
}

.tab-inner {
    width: vw(1318);
    max-width: calc(100% - 80px);
    margin: 0 auto;
}

.software-label {
    margin-bottom: vh(18);
    margin-left: vh(18);
    font-weight: bold;
    font-size: vw(18);
    color: #FFFFFF;
    line-height: vh(25);
    text-align: left;
}

.tab-list {
    display: flex;
    gap: vw(18);
}

.tab-item {
    position: relative;
    width: vw(316);
    padding: vh(28) vw(18);
    background: #23262B;
    border-radius: vw(8);
    border: 1px solid #2F3035;
    cursor: pointer;
    box-sizing: border-box;

    .tab-indicator {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        height: auto;
        pointer-events: none;
    }

    .tab-title {
        font-weight: 600;
        font-size: vw(18);
        color: #FFFFFF;
        line-height: vh(25);
        text-align: left;
    }

    .tab-desc {
        margin-top: vh(8);
        font-weight: 400;
        font-size: vw(16);
        color: rgba(255,255,255,0.6);
        line-height: vh(22);
        text-align: left;
    }
}

.dialog-content {
    width: 100%;
    height: 100%;
    background: #1454F4;
    border-radius: vw(8);
    border: 1px solid #2F3035;
}

// ::v-deep .experience-btn:hover {
//     background-color: #325fd3 !important;
//     border-color: #325fd3 !important;
// }

// ::v-deep .experience-btn:focus {
//     background-color: #386aea !important;
//     border-color: #386aea !important;
// }

@media (max-width: 1200px) {
    .tab-list {
        flex-wrap: wrap;
    }

    .tab-item {
        flex: 1 1 calc(50% - 8px);
        min-width: 240px;
    }
}

@media (max-width: 768px) {
    .new-download-container {
        padding: 48px 0 64px;
    }

    .content-left .title {
        font-size: 28px;
    }

    .tab-item {
        flex: 1 1 100%;
    }
}
</style>
